import { render, staticRenderFns } from "./ServiceHelp.vue?vue&type=template&id=901bfc54&"
import script from "./ServiceHelp.vue?vue&type=script&lang=js&"
export * from "./ServiceHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('901bfc54')) {
      api.createRecord('901bfc54', component.options)
    } else {
      api.reload('901bfc54', component.options)
    }
    module.hot.accept("./ServiceHelp.vue?vue&type=template&id=901bfc54&", function () {
      api.rerender('901bfc54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aARHhz913oDK/JS/comp/ServiceHelp.vue"
export default component.exports